/*
**    品牌相关路由
*/
export default [{
    path: 'brandEdit',
    name: 'brandEdit',
    meta: {
      title: '品牌资质编辑'
    },
    component: () =>
      import( /* webpackChunkName: "pop-brandEdit" */ '../views/brandManage/brand_edit.vue')
  },{
    path: 'brandAdd',
    name: 'brandAdd',
    meta: {
      title: '品牌资质新增'
    },
    component: () =>
      import( /* webpackChunkName: "pop-brandEdit" */ '../views/brandManage/brand_edit.vue')
  },{
    path: 'brandDetail',
    name: 'brandDetail',
    meta: {
      title: '品牌资质详情'
    },
    component: () =>
      import( /* webpackChunkName: "pop-brandEdit" */ '../views/brandManage/brand_detail.vue')
  }, {
    path: 'brandManage',
    name: 'brandManage',
    meta: {
      title: '品牌资质'
    },
    component: () =>
      import( /* webpackChunkName: "pop-brandManage" */ '../views/brandManage/index.vue')
  }, 
]